import React from 'react'
import PropTypes from 'prop-types'
import AlertContainer from 'react-alert'
import _ from 'lodash'
import EditPage from './EditPage'
import { Redirect } from 'react-router-dom'
import { createPage, getPage, updatePage, updatePages, deletePage, unpublishPage, deleteDraft, publishPage, listChildPages } from '../../api/pages'
import { arrayMove } from 'react-sortable-hoc'
import getConfig from '../../config'
const { WEBSITE_URI } = getConfig()

class EditPageContainer extends React.PureComponent {
  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'dark',
    time: 5000,
    transition: 'scale'
  }

  constructor (props, context) {
    super(props, context)

    this.state = {childPageOffset: 0, childPageLimit: 10, childPageNumber: 1, childPageTotal: 0}
  }

  componentDidMount () {
    this.loadPageData(this.props.match.params.pageId, this.state.childPageOffset, this.state.childPageLimit)
  }

  componentWillReceiveProps (nextProps) {
    // reload if page ID changes
    if (this.state.pageId !== parseInt(nextProps.match.params.pageId)) {
      // clear existing page data
      this.setState({
        pageId: null,
        slug: null,
        title: null,
        tabTitle: null,
        accentColor: null,
        sections: null,
        status: null,
        pages: null,
        childPageTotal: 0,
        childPageOffset: 0,
        childPageLimit: 10,
        childPageNumber: 1,
        parents: null,
        description: null
      }, () => {
        // load next page
        this.loadPageData(nextProps.match.params.pageId, this.state.childPageOffset, this.state.childPageLimit)
      })
    }
  }

  isScheduledForPast = () => {
    const { scheduledFor } = this.state
    if (scheduledFor) {
      const asDate = new Date(scheduledFor)
      // not epoch time and in past
      return asDate.getTime() !== new Date(0).getTime() &&
        asDate.getTime() <= Date.now()
    }
  }

  updateChildPageData = (selectedPageNumber) => {
    const offset = selectedPageNumber > 1 ? (selectedPageNumber - 1) * this.state.childPageLimit : 0
    this.setState({
      childPageOffset: offset,
      childPageNumber: selectedPageNumber
    }, async () => {
      try {
        const data = await listChildPages(this.state.pageId, this.state.childPageOffset, this.state.childPageLimit)
        const newState = {
          pages: data.rows,
          childPageTotal: data.total,
          childPageLimit: data.limit
        }
        this.setState(newState)
      } catch (err) {
        if (err && this.msg) {
          this.msg.show('Unable to retrieve pages', {
            time: 4000,
            type: 'error'
          })
        }
      }
    })
  }
  loadPageData = (pageId, offset, childPageLimit) => {
    // set page ID
    this.setState({
      pageId: !isNaN(pageId) && parseInt(pageId),
      sections: [],
      isLoading: true
    }, async () => {
      // get page
      try {
        const page = await getPage(pageId, {fetchLinkedBy: true})
        page.sections = page.sections || []
        page.version = page.version || null
        page.isLoading = false
        console.info(`GET page id:${page.id}`, 'v' + page.version, page.status)
        this.setState(page)
      } catch (error) {
        this.setState({isLoading: false})
        if (error.status === 404) {
          this.msg.show('Page not found', {type: 'error'})

          setTimeout(() => {
            this.props.history.push('/pages')
          }, 1000)
        } else {
          console.info('Error loading page:', error.message)
          console.error(error)
          this.msg.show('Error loading page', { type: 'error' })
        }
      }

      // get child pages
      try {
        const data = await listChildPages(pageId, offset, childPageLimit)
        const newState = {
          pages: data.rows,
          childPageTotal: data.total,
          childPageLimit: data.limit
        }
        this.setState(newState)
      } catch (err) {
        if (err && this.msg) {
          this.msg.show('Unable to retrieve pages', {
            time: 4000,
            type: 'error'
          })
        }
      }
    })
  }

  onTitleChange = (e) => {
    this.setState({ title: e.target.value, readOnly: true })
    const page = this.buildPageUpdate({ title: e.target.value })
    this.updatePage(page)
  }

  onDescriptionChange = (e) => {
    this.setState({ description: e.target.value, readOnly: true })
    const page = this.buildPageUpdate({ description: e.target.value })
    this.updatePage(page)
  }

  onHeadTitleChange = (e) => {
    this.setState({ headTitle: e.target.value, readOnly: true })
    const page = this.buildPageUpdate({ headTitle: e.target.value })
    this.updatePage(page)
  }

  onTabTitleChange = (e) => {
    this.setState({ tabTitle: e.target.value })
    const page = this.buildPageUpdate({ tabTitle: e.target.value })
    this.updatePage(page)
  }

  onAccentColorChange = (e) => {
    this.setState({ accentColor: e.target.value })
    const page = this.buildPageUpdate({ accentColor: e.target.value })
    this.updatePage(page)
  }

  onShowTabChange = (e) => {
    this.setState({ showTab: e.target.checked })
    const page = this.buildPageUpdate({ showTab: e.target.checked ? 1 : 0 })
    this.updatePage(page)
  }

  onHideTabsChange = (e) => {
    this.setState({ hideTabs: e.target.checked })
    const page = this.buildPageUpdate({ hideTabs: e.target.checked ? 1 : 0 })
    this.updatePage(page)
  }

  onSlugChange = (e) => {
    this.setState({ slug: e.target.value, readOnly: true })
    const page = this.buildPageUpdate({ slug: e.target.value })
    this.updatePage(page)
  }

  onCanonicalChange = (e) => {
    this.setState({ canonical: e.target.value, readOnly: true })
    const page = this.buildPageUpdate({ canonical: e.target.value })
    this.updatePage(page)
  }
  
  onDelete = async () => {
    try {
      await deletePage(this.state.pageId)
      this.setState({ redirectToList: true })
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'Could not delete page'
      console.info(errorMessage)
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }
  }

  onDeleteDraft = async () => {
    try {
      await deleteDraft(this.state.pageId)
      this.loadPageData(this.state.pageId, this.state.childPageOffset, this.state.childPageLimit)
      this.msg.show('Draft successfully deleted', { type: 'success', time: 4000 })
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }
  }

  onUnpublish = async () => {
    try {
      await unpublishPage(this.state.pageId)
      this.loadPageData(this.state.pageId, this.state.childPageOffset, this.state.childPageLimit)
      this.msg.show('Page successfully unpublished', { type: 'success', time: 4000 })
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }
  }

  onPreview = (path) => {
    const isPreview = !!this.state.draftId
    const parentSlugs = this.state.parents.length ? this.state.parents.map(parent => parent.slug).join('/') + '/' : ''
    let previewUrl = (typeof path === 'string') ? WEBSITE_URI + path : WEBSITE_URI + '/' + parentSlugs + this.state.slug
    if (isPreview) previewUrl += '?preview'
    // specifying window name ensures all previews for a given page open in the same tab/window
    window.open(previewUrl, 'preview_' + this.state.pageId)
  }

  onDirectPreview = (path) => {
    const isPreview = !!this.state.draftId
    let previewUrl = WEBSITE_URI + path
    if (isPreview) previewUrl += '?preview'
    // specifying window name ensures all previews for a given page open in the same tab/window
    window.open(previewUrl, 'preview_' + this.state.pageId)
  }

  buildPageUpdate = (update) => {
    return {
      id: this.state.id,
      parentId: this.state.parentId,
      title: this.state.title,
      sections: this.state.sections,
      version: this.state.version,
      ...update
    }
  }

  cloneSections = () => {
    return this.state.sections.map((section, i) => {
      const copy = Object.assign({}, section)
      // add a section version if it doesn't exist
      if (!copy.version) copy.version = i + '_' + new Date().getTime()
      return copy
    })
  }

  onAddSection = (index = 0) => {
    const sections = this.state.sections || []
    let layout = 'sidebar'
    // fragment layout types
    if (this.state.slug === 'homepage-carousel') layout = 'carousel'
    else if (this.state.slug === 'homepage-news') layout = 'news'
    else if (this.state.slug.includes('alert-banner')) layout = 'banner'
    else if (this.state.slug === 'maintenance-page') layout = 'maintenance'
    else if (this.state.slug === 'contact-us') layout = 'contact'

    const hasLanding = sections.find((section) => section.layout === 'landing')
    if (hasLanding) return alert('Landing section must be only section on page.')

    const newSection = {
      title: '',
      key: sections.length + '_' + new Date().getTime(),
      layout
    }
    if (this.state.slug === 'maintenance-page') {
      newSection.headline = 'This site is currently down for maintenance'
      newSection.description = 'We apologize for the inconvenience'
    } else if (this.state.slug === 'contact-us') {
      if (sections.length === 1 && index === 0) {
        index = 1
      }
      newSection.layoutType = 'officeAddress'
    }

    if (this.state.slug === 'homepage-carousel') this.setState({ sections: [newSection, ...sections] })
    else {
      const newSections = this.cloneSections()
      newSections.splice(index, 0, newSection)
      this.setState({ sections: newSections })
    }
  }

  onRemoveSection = (sectionIndex) => {
    const sections = this.cloneSections()
    sections.splice(sectionIndex, 1)
    this.onChangeSections(sections)
  }

  onMoveSection = (oldIndex, newIndex) => {
    const sections = this.cloneSections()
    sections.splice(newIndex, 0, sections.splice(oldIndex, 1)[0])
    this.onChangeSections(sections)
  }

  onCopySection = (index) => {
    const newSections = this.cloneSections()
    const newSection = Object.assign({}, newSections[index])
    newSection.title = (newSection.title || '') + ' - Copy'
    newSection.key = newSections.length + '_' + new Date().getTime()
    newSections.splice(index + 1, 0, newSection)
    this.setState({ sections: newSections })
    this.onChangeSections(newSections)
  }

  onSectionChange = (fieldName, data, sectionIndex) => {
    const sections = this.cloneSections()
    // update section data
    sections[sectionIndex][fieldName] = data
    this.onChangeSections(sections)
  }

  onChangeSections = sections => {
    this.setState({ sections }, () => {
      const page = this.buildPageUpdate({ sections })
      this.updatePage(page)
    })
  }

  requeueUpdatePage = (page) => {
    const prevVersion = page.version
    delete page.version
    const _page = this.buildPageUpdate({...page})
    console.info(`PUT id:${page.id} requeue`, 'v' + prevVersion, '=>', 'v' + _page.version)
    let requeueCount = this.state.requeueCount
    requeueCount += 1
    this.setState({requeueCount}, () => {
      this.updatePage(_page)
    })
  }

  copyPage = async () => {
    const pageTitle = this.state.title || ''

    const title = pageTitle + ' -Copy'
    let copySections = this.cloneSections()
    const newSections = [{
      content: {
        document: {
          nodes: [{
            kind: 'block',
            type: 'paragraph',
            nodes: [{ kind: 'text', text: '' }]
          }]
        }
      }
    }]

    if (!copySections || copySections.length === 0) {
      copySections = newSections
    }

    // build the page
    const page = {
      title: title,
      description: this.state.description,
      headTitle: this.state.headTitle,
      accentColor: this.state.accentColor,
      parentId: this.state.parentId && parseInt(this.state.parentId),
      sections: copySections
    }

    // start copying page
    this.setState({isCopying: true})

    // create page
    try {
      const newPage = await createPage(page)
      console.info(`Created new page id:${newPage.id}`)
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }

    // finished
    this.setState({isCopying: false})
  }

  updatePageNow = async (page) => {
    console.info(`Start PUT page id:${page.id}`, 'v' + page.version)
    let hasError = false

    const isSaving = this.state.isSaving
    const isSameAsLastSuccessfulPut = this.state.lastVersionSent &&
      this.state.lastVersionSent === page.version
    if (isSaving || isSameAsLastSuccessfulPut) {
      // PUT still saving, wait for the server to respond.
      // Avoid mismatch version.
      console.info('PUT aborted as still saving, would get mismatch')
      return this.requeueUpdatePage(page)
    }

    if (this.state.version !== page.version) {
      // PAGE was published requeue
      return this.requeueUpdatePage(page)
    }

    // start save
    this.setState({isSaving: true})

    // do update
    try {
      const newPage = await updatePage(this.state.pageId, page)
      // Update slug in case it changed on server
      const newState = {
        slug: newPage.slug,
        status: newPage.status,
        draftId: newPage.draftId,
        publishedId: newPage.publishedId,
        version: newPage.version,
        readOnly: false,
        requeueCount: 0,
        lastVersionSent: page.version
      }
      console.info('🎉 PUT ok', 'v' + newPage.version, newPage.status)
      newState.didModifySections = !!+newPage.didModifySections
      if (newPage.didModifySections) {
        newState.sections = newPage.sections
      }
      this.setState(newState)
    } catch (error) {
      hasError = true
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
      console.info('🔴 PUT error. Sent:', page, 'Error:', error.data ? error.data.message : error)
      if (error.status === 409) {
        this.msg.show('Try refreshing the page', { type: 'info', time: 6000 })
      }
    }

    // finished
    this.setState({isSaving: false})

    return !hasError
  }

  updatePage = _.debounce(this.updatePageNow, 2000)

  onPageSort = async (oldIndex, newIndex) => {
    const { pages } = this.state
    // Reorder pages
    const newPages = arrayMove(pages, oldIndex, newIndex)
    this.setState({
      pages: newPages
    })
    // Save new page order
    const newPageOrder = newPages.map((page, i) => { return { id: page.id, tabOrder: i } })
    try {
      await updatePages(newPageOrder)
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }
  }

  onResetDidModifySections = () => {
    this.setState({didModifySections: false})
  }

  onPublishLater = async (scheduledFor) => {
    // Sending in UTC format is not necessary but it
    // keeps things explicit.
    const scheduledForUTC = (new Date(scheduledFor)).toISOString()

    return new Promise(resolve => {
      this.setState({scheduledFor: scheduledForUTC, readOnly: true}, async () => {
        const page = this.buildPageUpdate({ scheduledFor: scheduledForUTC })
        const didSucceed = await this.updatePageNow(page)
        if (didSucceed) {
          this.msg.show('Successfully scheduled publishing', {type: 'success'})
        }
        return resolve(didSucceed)
      })
    })
  }

  onPublishNow = async () => {
    try {
      await publishPage(this.state.pageId)
      this.loadPageData(this.state.pageId, this.state.childPageOffset, this.state.childPageLimit)
      this.msg.show('Page successfully published', { type: 'success', time: 4000 })
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })
    }
  }

  render () {
    if (this.state.redirectToList) {
      return <Redirect to='/pages' />
    }

    return <div>
      { this.state.pageId &&
        <EditPage {...this.state}
          pageId={this.state.pageId}
          parentId={this.state.parentId}
          match={this.props.match}
          history={this.props.history}
          onTitleChange={this.onTitleChange}
          onHeadTitleChange={this.onHeadTitleChange}
          onDescriptionChange={this.onDescriptionChange}
          onTabTitleChange={this.onTabTitleChange}
          onAccentColorChange={this.onAccentColorChange}
          onShowTabChange={this.onShowTabChange}
          onHideTabsChange={this.onHideTabsChange}
          onResetDidModifySections={this.onResetDidModifySections}
          onSlugChange={this.onSlugChange}
          onCanonicalChange={this.onCanonicalChange}
          onSectionChange={this.onSectionChange}
          onAddSection={this.onAddSection}
          isScheduledForPast={this.isScheduledForPast}
          onRemoveSection={this.onRemoveSection}
          onMoveSection={this.onMoveSection}
          onCopySection={this.onCopySection}
          onDelete={this.onDelete}
          onPublishNow={this.onPublishNow}
          onPublishLater={this.onPublishLater}
          togglePublishModal={this.togglePublishModal}
          isPublishModalOpen={this.state.isPublishModalOpen}
          onPreview={this.onPreview}
          onDirectPreview={this.onDirectPreview}
          onUnpublish={this.onUnpublish}
          onCopyPage={this.copyPage}
          onDeleteDraft={this.onDeleteDraft}
          onChildPageChange={this.updateChildPageData}
          onPageSort={this.onPageSort} />
      }
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

EditPageContainer.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
}

export default EditPageContainer



// WEBPACK FOOTER //
// ./src/pages/EditPage/EditPageContainer.js